<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-06-11 14:08:29
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-06-11 16:20:44
 * @FilePath: \Lightingxj\src\views\set\ModifyLog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="modifyLogBody">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>修改记录</span>
      </div>
      <el-table :data="auditLogList" style="width: 100%" height="650">
        <el-table-column prop="id" label="ID" width="60"></el-table-column>
        <el-table-column prop="operatorName" label="操作人"></el-table-column>
        <el-table-column prop="operatorPhone" label="操作人电话" width="140"></el-table-column>
         <el-table-column label="操作人区域">
          <template slot-scope="scope">
            {{ getRegionName(scope.row.regionName) }}
          </template>
         </el-table-column>
        <el-table-column prop="operation" label="操作类型" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.operation === 'DELETE' ? 'danger' : 'success'" size="small">
              {{ scope.row.operation === 'DELETE' ? '删除' : scope.row.operation === 'CREATE' ? '新增' : scope.row.operation === 'UPDATE' ? '修改' : scope.row.operation }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="targetName" label="被操作对象名称"></el-table-column>
        <el-table-column prop="targetPhone" label="被操作对象电话" width="140"></el-table-column>
        <el-table-column prop="targetRegion" label="被操作对象区域">
          <template slot-scope="scope">
            {{ getRegionName(scope.row.targetRegion) }}
          </template>
        </el-table-column>
       
        <el-table-column label="操作时间" width="180">
          <template slot-scope="scope">
            {{ formatTime(scope.row.operateTime) }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  data() {
    return {
      auditLogList: [],
      regionMap: {
        '1': '阿克苏气象局',
        '2': '拜城工业园区',
        '3': '温宿产业园区',
        '4': '沙雅工业园区',
        '5': '新和县工业园区（西区）'
      }
    };
  },
  created() {
    this.getAuditLog();
  },
  methods: {
    formatTime(time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '';
    },
    getRegionName(code) {
      return this.regionMap[code] || code;
    },
    getAuditLog() {
      this.$axios({
        method: "get",
        url: `${this.$url2}/user/auditLog`
      }).then((res) => {
        console.log("auditLog返回结果:", res.data);
        if (res.data.success) {
          this.auditLogList = res.data.data;
        }
      });
    }
  }
};
</script>

<style scoped>
.modifyLogBody {
  width: 100%;
  min-height: calc(100vh - 84px);
  padding: 15px;
}
</style>
